import { IProduct, ITrackVariant, IVariant } from 'base/interfaces/product';
import { IProduct as IModProduct } from 'mod/product/interface';
import { IImage, IProductTag } from 'base/interfaces/product';
import { trackBuyNow } from 'base/utils/tracker';
import { COOKIE_BUY_NOW_DATA } from 'base/config/constant';
import { setCookie } from 'ava-util/dist/cookie';
import { RouteEnum } from 'pro/config/routers';
import router from 'next/router';
import { generatePath } from 'ava-util/dist/request';
import { filterFields } from 'ava-util/dist/data';
import {
    PRODUCT_KEYS,
    PRODUCT_TAG_TYPES,
    ProductTagType,
    ProductType,
    IBuyNowParmas,
    IVariantNum,
} from 'base/interfaces/product';
import { getTargetImage } from 'base/utils/getPicUrl';
import { nativeBuyNow } from 'base/utils/app';
import { getStoreState } from 'base/store';
import { sum } from 'base/utils/arr';
import { TDetailElement } from '@app/common/ProductDetailPopup/ProductDetail';
import { isEmpty } from 'ava-util/dist/data';
import { IListProduct } from 'mod/product-list/interface';
import site from 'pro/config/site';
import { TDiscountStyle } from 'mod/product/interface';
import { IBuyNowData } from 'base/interfaces/checkout';

export function trans2Product(item: Record<string, any>, keyMap: Record<string, string>): ProductType {
    const prod: ProductType = {};
    Object.keys(item).forEach((key) => {
        if (key in keyMap && PRODUCT_KEYS.includes(keyMap[key])) {
            prod[keyMap[key] as keyof ProductType] = item[key];
        } else if (PRODUCT_KEYS.includes(key)) {
            prod[key as keyof ProductType] = item[key];
        }
    });
    return prod;
}

/**
 * 获取指定 variantId 图片列表
 * 没有指定id 返回 type == "0" 的商品图列表
 */
export function getVariantImages(variantId: string, images: IImage[]): IImage[] {
    let _images = images.filter(item => item.productVariantId === variantId)

    if (!_images.length) {
        _images = images.filter((item) => Number(item.type) === 0);
    }

    return _images;
}

export function getVariantMainImage(images: IImage[], variantId: string): IImage | undefined {
    const vImages = getVariantImages(variantId, images);
    if (vImages.length) {
        return vImages.find(item => item.isMain) || vImages[0];
    }
    return void 0;
}

export function getVariantMainSrc(variantId: string, images: IImage[]): string {
    const image = getVariantMainImage(images, variantId);
    return image?.picLink || images[0]?.picLink || '';
}

export const getTagType = (tags?: IProductTag[]): ProductTagType | undefined => {
    if (tags && tags.length > 0) {
        // 去除空格 变为小写
        const list = tags.map(item => item.tag.replace(/\s+/g, '').toLocaleLowerCase());
        return PRODUCT_TAG_TYPES.find(type => list.includes(type.toLocaleLowerCase()));
    }
    return void 0;
};

export const hasSpec = (shownVariant?: IVariant) => {
    return !!(shownVariant?.productAttributeList?.length);
};

export const checkPreSale = (variantTags: IProductTag[] = [], spuTags: IProductTag[] = []) => {
    return !!([...variantTags, ...spuTags].find(item => item.tag === 'presale'));
};

export const buySkipCart = (parmas: IBuyNowParmas) => {
    const { ua: { isApp } } = getStoreState('rootStore');
    const {
        revenue,
        trackItems,
        storageItems,
        refererType = 'skipCart',
        cacheKey,
    } = parmas;

    trackBuyNow({
        items: trackItems,
        orderInfo: {
            id: '',
            revenue
        }
    });
    if (isApp) {
        nativeBuyNow({
            variantNums: storageItems,
            source: refererType,
            cacheKey,
        });
    } else {
        const buyNowData: IBuyNowData = {
            variantNums: storageItems,
            source: refererType,
        }

        setCookie(COOKIE_BUY_NOW_DATA, JSON.stringify(buyNowData));
        // setCookie(COOKIE_VARIANT_NUMS_ITEMS, JSON.stringify(storageItems));

        router.push(generatePath(RouteEnum.CHECKOUT, {
            refererType,
            cacheKey
        }));
    }
};

export const getVariantSummary = (variant: IVariant, checkedAddOns: string[], qty: number): {
    totalPrice: number;
    retailPrice?: number;
} => {
    let total: number;
    let retail: number | undefined;
    let addOnsTotal = 0;
    if (variant.addOns.length > 0 && checkedAddOns.length > 0) {
        for (const item of variant.addOns) {
            if (checkedAddOns.includes(item.variantId)) {
                addOnsTotal += (
                    item.dealPriceExchangeDisplay
                        ? Number(item.dealPriceExchange)
                        : Number(item.shopPriceExchange)
                );
            }
        }
    }

    if (variant.dealPriceExchangeDisplay) {
        total = Number(variant.dealPriceExchange) + addOnsTotal;
        retail = Number(variant.shopPriceExchange) + addOnsTotal;
    } else {
        total = Number(variant.shopPriceExchange) + addOnsTotal;
    }

    return {
        totalPrice: total * qty,
        retailPrice: retail ? retail * qty : undefined
    }
}

export const getAddOnsSrcList = () => {
    const items = document.querySelectorAll('.js-add-ons-checked');
    return Array.from(items).map(item => item.querySelector('img')?.currentSrc)
};

export const filterProductFields = (product: IProduct): IProduct => {
    const _product: IProduct = filterFields(product, [
        'trackId',
        'productTrackCode',
        'variantTrackCode',
        'categoryTrackCode',
        'listTrackCode',
        'productId',
        'variantId',
        'isStock',
        'link',
        'name',
        'discountPriceNumDisplay',
        'discountLocalPriceNumDisplay',
        'discountMode',
        'reviewNum',
        'reviewScore',
        'shopPrice',
        'shopPriceExchangeDisplay',
        'dealPrice',
        'dealPriceExchangeDisplay',
        'dealerShopPriceExchangeDisplay',
        'flashSale',
        'points',
        'activity',
        'pointsMall',
        'energyLabel',
    ]);
    const mainImage = getTargetImage(product.images, undefined, 'isMain')
    const hoverImage = getTargetImage(product.images, undefined, 'isListHover')
    _product.picLink = mainImage?.picLink || '';
    _product.altText = mainImage?.altText || '';
    _product.hoverAssetLink = hoverImage?.picLink || '';
    _product.hoverAltText = hoverImage?.altText || '';

    const tagType = getTagType(product.productTags);
    if (tagType) {
        _product.tag = tagType
    }
    // TODO: wholesale remove
    // _product.dealerShopPriceExchangeDisplay = '$5.00'
    return _product;
}

export const filterProductsFields = (list: IProduct[]): IProduct[] => {
    return list.map(item => filterProductFields(item));
}

// 打点的sku根据域名区分前缀
export function getTrackerSkuPrefix(country: string): string {
    const countrySkuPrefixMap: Record<string, string> = {
        DE: 'de:eur:de:',
        AU: 'au:aud:en:',
        CA: 'CA:CAD:en:',
        GB: 'gb:gbp:en:',
    }
    if (site.brand === 'Vivohome') {
        return 'us:usd:en:';
    }
    return countrySkuPrefixMap[country] || '';
}

export const getProductDiscount = (
    product: IProduct | IVariant,
): string => {
    const { discountLocalPriceNumDisplay, discountPriceNumDisplay } = product
    return discountLocalPriceNumDisplay || discountPriceNumDisplay; //老接口不一定存在discountLocalPriceNumDisplay
}

export const getTagDiscountText = (
    product: IProduct | IVariant,
    addOnText?: TDiscountStyle
): string => {
    const data = getProductDiscount(product);
    if (!data) {
        return ''
    }
    if (addOnText == 'OFF') {
        return `${data} OFF`
    }
    return `-${data}`;
}

export const isBonusProduct = (prod: Record<string, any>): boolean => {
    const { tradeIn } = prod;
    if (!tradeIn) {
        return false
    }
    const tradeInTypeKey = 'bonusItemVariantTradeInType' in tradeIn ? 'bonusItemVariantTradeInType' : 'tradeInType';
    return (['amount', 'points']).includes(prod.tradeIn[tradeInTypeKey])
};


/**
 * 众筹赠品 free价格，tag === 'Bonus' && !!activityCode
 * @param prod
 */
export const isCrowdFundingFreePrice = (prod: Record<string, any>): boolean => {
    const { tag = '', crowdFunding } = prod || {};
    if (!tag || !crowdFunding) {
        return false;
    }
    return tag.toLowerCase() === 'bonus' && !!crowdFunding.activityCode
}

/**
 * 众筹商品 tag === 'CrowdFunding' && !!activityCode
 * @param prod
 */
export const isCrowdFundingProduct = (prod: Record<string, any>): boolean => {
    const { tag = '', crowdFunding } = prod || {};
    if (!tag || !crowdFunding) {
        return false;
    }
    return tag.toLowerCase() === 'crowdfunding' && !!crowdFunding?.activityCode
}

const bonusProductPriceConfig = {
    cartProdPrice: {
        checkKey: 'dealPriceExchange',
        displayKey: 'dealPriceExchangeDisplay'
    },
    orderProdPrice: {
        checkKey: 'variantPriceExchange',
        displayKey: 'variantPriceExchangeDisplay'
    },
}
export const getBonusProductPrice = (prod: Record<string, any>): string => {
    const { tradeIn } = prod;
    if (tradeIn?.tradeInType === 'points' || tradeIn?.bonusItemVariantTradeInType === 'points') {
        return `${tradeIn.points} Points`;
    }

    const type = 'tradeInType' in tradeIn ? 'cartProdPrice' : 'orderProdPrice';
    const { checkKey, displayKey } = bonusProductPriceConfig[type];
    return Number(tradeIn[checkKey]) > 0 ? tradeIn[displayKey] : 'FREE'
}

export const isSoldOut = (variant: IVariant | IProduct | IModProduct): boolean => {
    if ('stockNum' in variant) {
        return variant.stockNum < 1;
    }
    return Number(variant.isStock) === 0;
};

export const canAddToCart = (variant: IVariant | IProduct | IListProduct): boolean => {
    return !variant.disableActions?.includes('addToCart');
};

export const canBuyNow = (variant: IVariant | IProduct): boolean => {
    return !variant.disableActions?.includes('buyNow');
};

export const getVariantNums = (variants: Array<IVariant | IProduct>, qty: number): IVariantNum[] => {
    return variants.map(variant => ({
        variantId: variant.variantId,
        num: qty
    }));
};

export const getVariantsTrackItem = (variant: ITrackVariant): ITrackVariant => {
    return filterFields(variant, [
        'variantId',
        'trackId',
        'productId',
        'productTrackCode',
        'variantTrackCode',
        'categoryTrackCode',
        'shopPrice',
        'dealPrice',
        'num',
        'productName',
    ])
}

export const getVariantsTrackItems = (variants: Array<ITrackVariant>, qty?: number): ITrackVariant[] => {
    return variants.map(variant => typeof qty === 'undefined' ? getVariantsTrackItem(variant) : ({
        ...getVariantsTrackItem(variant),
        num: qty,
    }));
};

export const getVariantsTrackRevenue = (variants: Array<IVariant | IProduct>, qty: number): string => {
    const prices = variants.map(variant => {
        let price = Number(variant.dealPrice || 0);
        if (price === 0) {
            price = Number(variant.shopPrice);
        }
        return price * qty;
    });
    return sum(prices).toFixed(2);
}

export const isShownDetailElement = (element: TDetailElement, elements?: TDetailElement[], hiddenElements?: TDetailElement[]): boolean => {
    if (!isEmpty(elements)) {
        return elements!.includes(element);
    }
    if (!isEmpty(hiddenElements)) {
        return !hiddenElements!.includes(element);
    }
    return true;
}